import produto from '@/core/apiclient/ProdutoApiClient'
import usuario from '@/core/apiclient/UsuarioApiClient'
import ata from '@/core/apiclient/ata/AtaApiClient'
import processo from '@/core/apiclient/ProcessoApiClient'
import itemProcesso from '@/core/apiclient/ItemProcessoApiClient'
import itemAta from '@/core/apiclient/ItemAtaApiClient'
import fornecedor from '@/core/apiclient/FornecedorApiClient'
import tipo from '@/core/apiclient/TipoApiClient'
import fornecedorItemAta from '@/core/apiclient/FornecedorItemAtaApiClient'
import realinhamento from '@/core/apiclient/RealinhamentoApiClient'
import aditamento from '@/core/apiclient/AditamentoApiClient'
import alterarFornecedor from '@/core/apiclient/AlterarFornecedorApiClient'
import bloqueio from '@/core/apiclient/BloqueioApiClient'
import alterarClassificacao from '@/core/apiclient/AlterarClassificacaoApiClient'
import parametrosDoSistema from '@/core/apiclient/configuracao/ParametrosSistemaApiClient'
import modeloDocumento from '@/core/apiclient/configuracao/modelo-documento/ModeloDocumentoApiClient'
import tipoModeloDocumento from '@/core/apiclient/configuracao/tipo-modelo-documento/TipoModeloDocumentoApiClient'
import documentosAta from '@/core/apiclient/ata/documentos-ata/DocumentosAtaApiClient'
import documentosAtaEditorTexto from '@/core/apiclient/ata/documentos-ata/documentos/editor-texto/DocumentoEditorTextoApiClient'
import documentosAtaAnexo from '@/core/apiclient/ata/documentos-ata/anexos/AnexosApiClient'
import documentoProcessoDigital from '@/core/apiclient/ata/documentos-ata/processo-digital/DocumentoProcessoDigitalApiClient'
import arquivoTemporario from '@/core/apiclient/arquivo-temporario/ArquivoTemporarioApiClient'
import flowbee from '@/core/apiclient/flowbee/FlowbeeApiClient'
import pedido from '@/core/apiclient/pedido/PedidoApiClient'
import gestaoPedido from '@/core/apiclient/ata/gestao-pedido/GestaoPedidoApiClient'
import itemPedido from '@/core/apiclient/item-pedido/ItemPedidoApiClient'
import documentosPedido from '@/core/apiclient/pedido/documentos/DocumentosPedidoApiClient'
import documentosPedidoAnexo from '@/core/apiclient/pedido/documentos/anexo/AnexoApiClient'
import documentosPedidoEditorTexto from '@/core/apiclient/pedido/documentos/documento/editor-texto/DocumentoEditorTextoApiClient'
import transferencia from '@/core/apiclient/TransferenciaApiClient'
import desentranhamentoDocumentoAta from '@/core/apiclient/ata/documentos-ata/processo-digital/desentranhamento/DesentranhamentoDocumentoAtaApi'
import documentoPedidoProcessoDigital from '@/core/apiclient/pedido/documentos/processo-digital/DocumentoPedidoProcessoDigitalApiClient'
import desentranhamentoDocumentoPedido from '@/core/apiclient/pedido/documentos/processo-digital/desentranhamento/DesentranhamentoDocumentoAtaApi'
import signatariosAtaApiClient from '@/core/apiclient/ata/documentos-ata/processo-digital/signatario/SignatariosAtaApiClient'
import signatarioPedidoApiClient from '@/core/apiclient/pedido/documentos/processo-digital/signatario/SignatarioPedidoApiClient'
import dotacaoOrcamentariaApiClient from '@/core/apiclient/pedido/dotacao-orcamentaria/DotacaoOrcamentariaPedidoApiClient'
import setupDotacaoOrcamentariaPedidoApiClient from '@/core/apiclient/pedido/dotacao-orcamentaria/setup/SetupDotacaoOrcamentariaPedidoApiClient'
import itemPedidoEstorno from '@/core/apiclient/item-pedido/estorno/ItemPedidoEstornoApiClient'
import acompanhamentoAta from '@/core/apiclient/ata/acompanhamento/AcompanhamentoApiClient'
import gerarRelatorio from '@/core/apiclient/gerar-relatorio/GerarRelatorioApiClient'
import adesao from '@/core/apiclient/adesao/AdesaoApiClient'
import itemAdesao from '@/core/apiclient/item-adesao/ItemAdesaoApiClient'
import documentosAdesao from '@/core/apiclient/adesao/documentos-adesao/DocumentosAdesaoApiClient'
import documentosGenerico from '@/core/apiclient/documentos/DocumentosApiClient'
import documentoEditorTextoGenerico from '@/core/apiclient/documentos/editor-texto/DocumentoEditorTextoApiClient'
import itensAdesao from '@/core/apiclient/adesao/itens-adesao/ItensAdesaoApiClient'
import comprasLegado from '@/core/apiclient/compras-legado/ComprasLegadoApiClient'
import processoUtilizacao from '@/core/apiclient/processo-utilizacao/ProcessoUtilizacaoApiClient'
import gestaoAta from '@/core/apiclient/ata/gestao-ata/GestaoAtaApiClient'
import ocorrencia from '@/core/apiclient/ocorrencia/OcorrenciaApiClient'
import adesaoBpmApiClient from '@/core/apiclient/adesao/bpm/AdesaoBpmApiClient'
import ataFiscais from '@/core/apiclient/ata/fiscais/FiscaisApiClient'
import penalidadesGenerico from '@/core/apiclient/penalidades/PenalidadesApiClient'
import permissionamento from '@/core/apiclient/PermissionamentoApiClient'
import aditivoApostila from '@/core/apiclient/aditivo-apostila/AditivoApostilaApiClient'
import itensAditivoApostila from '@/core/apiclient/aditivo-apostila/itens/ItensAditivoApostilaApiClient'
import notificacoesPenalidade from '@/core/apiclient/penalidades/notificacoes/PenalidadesNotificacoesApiClient'
import fiscais from '@/core/apiclient/configuracao/fiscais/FiscaisApiClient'
import controleSaldosOrgao from '@/core/apiclient/ata/controle-saldos-orgao/ControleSaldosOrgaoApiClient'
import revisoes from '@/core/apiclient/configuracao/revisoes/RevisoesApiClient'
import bpm from '@/core/apiclient/bpm/BpmApiClient'
import modeloDocumentoRevisao from '@/core/apiclient/configuracao/revisoes/modelo-documento-revisao/ModeloDocumentoRevisaoApiClient'
import revisoesPedidoUtilizacao from '@/core/apiclient/pedido/revisoes/RevisoesPedidoUtilizacaoApiClient'
import itemAdesaoEstorno from '@/core/apiclient/item-adesao/estorno/ItemAdesaoEstornoApiClient'
import revisoesAdesao from '@/core/apiclient/adesao/revisoes/RevisoesAdesaoApiClient'
import partesEnvolvidas from '@/core/apiclient/partes-envolvidas/PartesEnvolvidasApiClient'

export default {
	produto,
	usuario,
	ata,
	processo,
	itemProcesso,
	itemAta,
	fornecedor,
	tipo,
	realinhamento,
	fornecedorItemAta,
	aditamento,
	alterarFornecedor,
	bloqueio,
	alterarClassificacao,
	parametrosDoSistema,
	documentosAta,
	modeloDocumento,
	tipoModeloDocumento,
	documentosAtaEditorTexto,
	documentosAtaAnexo,
	arquivoTemporario,
	documentoProcessoDigital,
	flowbee,
	pedido,
	gestaoPedido,
	itemPedido,
	documentosPedido,
	documentosPedidoAnexo,
	documentosPedidoEditorTexto,
	transferencia,
	desentranhamentoDocumentoAta,
	documentoPedidoProcessoDigital,
	desentranhamentoDocumentoPedido,
	signatarioPedidoApiClient,
	signatariosAtaApiClient,
	itemPedidoEstorno,
	dotacaoOrcamentariaApiClient,
	setupDotacaoOrcamentariaPedidoApiClient,
	acompanhamentoAta,
	gerarRelatorio,
	adesao,
	itemAdesao,
	documentosAdesao,
	documentosGenerico,
	documentoEditorTextoGenerico,
	itensAdesao,
	comprasLegado,
	processoUtilizacao,
	gestaoAta,
	ocorrencia,
	adesaoBpmApiClient,
	ataFiscais,
	penalidadesGenerico,
	notificacoesPenalidade,
	permissionamento,
	aditivoApostila,
	itensAditivoApostila,
	fiscais,
	controleSaldosOrgao,
	revisoes,
	bpm,
	modeloDocumentoRevisao,
	revisoesPedidoUtilizacao,
	itemAdesaoEstorno,
	revisoesAdesao,
	partesEnvolvidas,
}
